import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'
import {
  hideScrollbarMixin,
  customizeVerticalScrollbarThumbMixin
} from 'styles/mixins'

export const SoundsListContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  margin-right: -16px;
`

export const SoundsListWrapper = styled.div<{
  $paddingTop: string | undefined
}>`
  height: 100%;
  & > div {
    ${customizeVerticalScrollbarThumbMixin()};

    @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
      ${hideScrollbarMixin()};
    }
  }
`

export const RowWrapper = styled.div`
  padding-bottom: 8px;
  padding-right: 16px;
`
